export default __webpack_public_path__ + "static/media/widget_watchbox_vpmspx60_sell.d4a8899a.mp3";